/**
 * @property widthPercent - determines how much of its structure's width container occupies in percents
 */
const containerAttributes = {
  widthPercent: 'width-percent',
};

/**
 * @property blocks - list of blocks available for insertion through quick actions
 */
const emptyContainerAttributes = {
  ...containerAttributes,
  blocks: 'blocks',
};

/**
 * @property src - image url
 * @property alt - image alt text
 * @property href - URL image hyperlink points to
 */
const imageAttributes = {
  src: 'src',
  alt: 'alt',
  href: 'href',
  width: 'width',
  height: 'height',
};

/**
 * @property href - URL button hyperlink points to
 */
const buttonAttributes = {
  href: 'href',
};

/**
 * @description List of attributes supported by corresponding Block ({@link BlockType}).
 */
export const BlockAttr = {
  EMPTY_CONTAINER: emptyContainerAttributes,
  CONTAINER: containerAttributes,
  BLOCK_IMAGE: imageAttributes,
  BLOCK_BUTTON: buttonAttributes,
};
